import React, {Component} from 'react';
import './App.css';
import {createStore, Dispatch} from "redux";
import {State, appReducer} from "./reducer";
import {connect, ConnectedProps} from "react-redux";
import {BrowserRouter, Switch,Route} from "react-router-dom";
import Login from './Login';
import Home from './Home';
import Logout from './Logout';
import ForgotPw from './ForgotPw';
import Account from './Account'
import Register from './Register';
import NewServerStart from './NewServerStart';
import Payment from './Payment';
import SetupServerFinish from './SetupServerFinish';

export const store = createStore(appReducer)

const mapStateToProps = (state: State) => {
  return {
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps);

class App extends Component<ConnectedProps<typeof connector> >
{
  render() {
    return (
      <BrowserRouter>
          <Switch>
            <Route exact path="/app/home">
              <Home />
            </Route>
            <Route exact path="/app/logout">
              <Logout />
            </Route>
            <Route exact path="/app/forgot_pw">
              <ForgotPw />
            </Route>
            <Route exact path="/app/account_settings">
              <Account />
            </Route>
            <Route exact path="/app/register">
              <Register />
            </Route>
            <Route exact path="/app/new_server_start">
              <NewServerStart />
            </Route>
            <Route exact path="/app/payment">
              <Payment />
            </Route>
            <Route exact path="/app/setup_server_finish/:saved_server_uuid">
              <SetupServerFinish />
            </Route>
            <Route path="/">
              <Login />
            </Route>
          </Switch>
      </BrowserRouter>
    );
  }
}

export default connector(App)